import axios from "../axios";

/**
 * Validate a consolidation or subdivision against the backend.
 * The backend checks current share distribution and confirms the
 * new values are legally permissible.
 */
const validate = (data) => {
  return axios
    .post(`/share-consolidation-subdivision/validate`, data)
    .then((response) => response.data)
    .catch((error) => {
      console.error("Server response:", error);
      throw error;
    });
};

/**
 * Persist a confirmed consolidation or subdivision transaction.
 */
const submit = (data) => {
  return axios
    .post(`/share-consolidation-subdivision`, data)
    .then((response) => response.data)
    .catch((error) => {
      if (error.response) {
        console.error("Server response:", error.response);
      }
      throw error;
    });
};

/**
 * Fetch existing consolidation / subdivision records for a company.
 */
const getList = (companyId) => {
  return axios
    .get(`/share-consolidation-subdivision?companyId=${companyId}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

/**
 * Fetch a single record by id.
 */
const getById = (id) => {
  return axios
    .get(`/share-consolidation-subdivision/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

/**
 * Update an existing record (e.g. correct a pending transaction).
 */
const update = (id, data) => {
  return axios
    .put(`/share-consolidation-subdivision/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

/**
 * Delete / reverse a pending record.
 */
const remove = (id) => {
  return axios
    .delete(`/share-consolidation-subdivision/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
};

const shareConsolidationSubdivisionService = {
  validate,
  submit,
  getList,
  getById,
  update,
  remove,
};

export default shareConsolidationSubdivisionService;